import React from 'react';
import { createRoot } from 'react-dom/client';
import { AdminAIModelsPage, type AdminAIModelsPageProps } from '../ui/admin/AdminAIModelsPage';

export function AdminAIModelsPageContainer(props: AdminAIModelsPageProps) {
  return <AdminAIModelsPage {...props} />;
}

export function mountAdminAIModelsPage(
  container: HTMLElement,
  props: AdminAIModelsPageProps
) {
  const root = createRoot(container);
  root.render(<AdminAIModelsPageContainer {...props} />);
  return root;
}

export default AdminAIModelsPageContainer;
